import { FC, ReactNode } from 'react';
import { Avatar, Tag } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { VirtualizedList as List } from '@/shared';
import { ellipsisStyling } from '@/utilities';

interface DeveloperCredentialListItemProps {
    avatarIcon: ReactNode;
    avatarSrc?: string;
    description?: ReactNode;
    extra: ReactNode;
    itemKey: string;
    name: string;
    status: string;
    statusColor?: string;
}

const DeveloperCredentialListItem: FC<DeveloperCredentialListItemProps> = ({
    avatarIcon,
    avatarSrc,
    description,
    extra,
    itemKey,
    name,
    status,
    statusColor = 'green',
}) => {
    const { token } = useAntDesignTheme();

    return (
        <List.Item key={itemKey} extra={extra} style={{ minHeight: '5rem' }}>
            <List.Item.Meta
                style={{ alignItems: 'center' }}
                avatar={
                    <Avatar
                        size={48}
                        shape='square'
                        src={avatarSrc}
                        icon={avatarIcon}
                        style={{
                            backgroundColor: token.colorFillQuaternary,
                            border: `1px solid ${token.colorBorder}`,
                        }}
                    />
                }
                title={
                    <span
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: token.marginXS,
                            minWidth: 0,
                        }}
                    >
                        <span style={{ maxWidth: '16rem', minWidth: 0, ...ellipsisStyling }}>{name}</span>
                        <Tag bordered={false} color={statusColor} style={{ flex: 'none', marginInlineEnd: 0 }}>
                            {status}
                        </Tag>
                    </span>
                }
                description={description}
            />
        </List.Item>
    );
};

export default DeveloperCredentialListItem;
